// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"U4-z","colorTextValue":"V4-z","swatches":"W4-z","collapseLink":"X4-z","isCollapsed":"Y4-z","dropdown":"Z4-z","disabled":"_4-z"};